import Spinner from '@/components/design-system/spinner'
import './notifications-loading.scss'

export default function NotificationsLoading() {
  return (
    <div className='notifications-loading'>
      <Spinner />
    </div>
  )
}
